/* eslint-disable */ import { assertNumber, distanceDimensionComponent, memoEval, sceneEntityObjectPropertiesComponent } from '@salsita-ai/platform-project-sdk/domain';
import { attachComponent } from '../implementation.js';
export const topWithWidthAndLengthComponents = [
    attachComponent.withComponent(sceneEntityObjectPropertiesComponent, 'top', true).withAlias('TopWithWidthAndLength').attach(memoEval(// @ts-ignore
    (self)=>// keep deps on a separate line so @ts-ignore only covers the parameter
        [
            self.$offsetY,
            self.$thicknessValue,
            self.$thicknessScaleZero,
            self.$thicknessScaleOne,
            self.width,
            self.$widthScaleZero,
            self.$widthScaleOne,
            self.length,
            self.$lengthScaleZero,
            self.$lengthScaleOne,
            self.$distance,
            self.$distanceScaleZero,
            self.$distanceScaleOne,
            self.$leafBevel,
            self.$leafBevelScaleZero,
            self.$leafBevelScaleOne,
            self.$bevelThickness,
            self.$bevelScaleZero,
            self.$bevelScaleOne
        ], ($offsetY, $thicknessValue, $thicknessScaleZero, $thicknessScaleOne, width, $widthScaleZero, $widthScaleOne, length, $lengthScaleZero, $lengthScaleOne, $distance, $distanceScaleZero, $distanceScaleOne, $leafBevel, $leafBevelScaleZero, $leafBevelScaleOne, $bevelThickness, $bevelScaleZero, $bevelScaleOne)=>({
            offsetY: $offsetY,
            morphTargetInfluences: {
                thickness: {
                    value: $thicknessValue,
                    scaleZero: $thicknessScaleZero,
                    scaleOne: $thicknessScaleOne
                },
                width: {
                    value: width,
                    scaleZero: $widthScaleZero,
                    scaleOne: $widthScaleOne
                },
                length: {
                    value: length,
                    scaleZero: $lengthScaleZero,
                    scaleOne: $lengthScaleOne
                },
                distance: {
                    value: $distance,
                    scaleZero: $distanceScaleZero,
                    scaleOne: $distanceScaleOne
                },
                leafBevel: {
                    value: $leafBevel,
                    scaleZero: $leafBevelScaleZero,
                    scaleOne: $leafBevelScaleOne
                },
                bevel: {
                    value: $bevelThickness,
                    scaleZero: $bevelScaleZero,
                    scaleOne: $bevelScaleOne
                }
            }
        }))),
    attachComponent.withComponent(distanceDimensionComponent, 'width', true).withAlias('TopWithWidthAndLength').attach(memoEval(// @ts-ignore
    (self)=>// keep deps on a separate line so @ts-ignore only covers the parameter
        [
            self.width,
            self.$minWidth,
            self.$maxWidth
        ], (width, $minWidth, $maxWidth)=>({
            value: width,
            min: $minWidth,
            max: $maxWidth
        })), (state)=>{
        assertNumber(state.value);
        return {
            width: state.value
        };
    }),
    attachComponent.withComponent(distanceDimensionComponent, 'length', true).withAlias('TopWithWidthAndLength').attach(memoEval(// @ts-ignore
    (self)=>// keep deps on a separate line so @ts-ignore only covers the parameter
        [
            self.length,
            self.$minLength,
            self.$maxLength
        ], (length, $minLength, $maxLength)=>({
            value: length,
            min: $minLength,
            max: $maxLength
        })), (state)=>{
        assertNumber(state.value);
        return {
            length: state.value
        };
    })
];

//# sourceMappingURL=top-with-width-and-length.js.map